type Handler<T> = (event: T) => void | Promise<void>;

export interface IEventEmitter<Events extends Record<string, unknown>> {
  on<K extends keyof Events>(event: K, handler: Handler<Events[K]>): void;
  off<K extends keyof Events>(event: K, handler: Handler<Events[K]>): void;
}

export class EventEmitter<
  Events extends Record<string, unknown>,
> implements IEventEmitter<Events> {
  private listeners: { [K in keyof Events]?: Handler<Events[K]>[] } = {};

  on<K extends keyof Events>(event: K, handler: Handler<Events[K]>) {
    (this.listeners[event] ??= []).push(handler);
  }

  off<K extends keyof Events>(event: K, handler: Handler<Events[K]>) {
    this.listeners[event] = (this.listeners[event] ?? []).filter((h) => h !== handler);
  }

  async emit<K extends keyof Events>(event: K, payload: Events[K]): Promise<void> {
    const handlers = this.listeners[event] ?? [];
    await Promise.allSettled(handlers.map((h) => Promise.resolve(h(payload))));
  }
}
